module.exports = __webpack_public_path__ + "static/media/legacy.d241f202.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/enhanced-brand/legacy.jpg
// module id = 1197
// module chunks = 0